import { render, staticRenderFns } from "./inland.vue?vue&type=template&id=60643abe&scoped=true"
import script from "./inland.vue?vue&type=script&lang=js"
export * from "./inland.vue?vue&type=script&lang=js"
import style0 from "./inland.vue?vue&type=style&index=0&id=60643abe&prod&scoped=true&lang=css"
import style1 from "./inland.vue?vue&type=style&index=1&id=60643abe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60643abe",
  null
  
)

export default component.exports